export default __webpack_public_path__ + "static/media/Lincoln-Financial-Logo.a14f0de2.png";